import { notification } from "antd";
import { defineMessages, IntlShape } from "react-intl";

interface IProps {
    intl: IntlShape;
    reset: () => void;
}

const MESSAGES = defineMessages({
    productionOrdersNotFound: {
        id: "production_orders_not_found_notification.message",
        defaultMessage: "Geen productie orders gevonden voor deze referentie"
    }
});

export const ProductionOrdersNotFoundNotification = (props: IProps) => {
    notification.error({
        message: props.intl.formatMessage(MESSAGES.productionOrdersNotFound),
        onClose: () => props.reset(),
        placement: "bottomRight",
    });
    return null;
};
